let customChangeEvent = new Event('change');

window.addEventListener('load', function () {
    const intervalId = setInterval(() => {
        const bold = document.querySelector('.bold_options_loaded');
        if (bold) {
            clearInterval(intervalId);
            if (document.querySelector('.add_to_cart').textContent.trim() == 'RUPTURE') return;
            setTimeout(() => {
                if (document.querySelector('.shopcircle-custom') && document.querySelector('.num-of-choices')) {
                    if (innerWidth < 500) {
                        document.querySelector('.shopcircle-custom').style.display = 'flex';
                    } else {
                        document.querySelector('.shopcircle-custom').style.display = 'block';
                    }
                }
                createSelector();
                modalEvents();
                document.querySelector('.modal-main-custom').prepend(document.querySelector('.nail-choices').cloneNode(true));
                document.querySelector('.bold_clone').setAttribute('disabled', 'disabled');
                document.querySelector('.bold_clone > span').textContent = 'Choisissez vos couleurs';
                colorCategory();
                displayLoader();
                document.querySelectorAll('.bold_await_load').forEach((element)=>{
                    element.classList.remove('bold_await_load');
                });
                document.querySelectorAll('.bold_option_checkbox input[type="checkbox"]')[0]?.click();
                document.querySelectorAll('.bold_option_checkbox input[type="checkbox"]')[1]?.click();
                applyNoveauClass();
            }, 200);
        }
const oosMessages = document.querySelectorAll('.bold_out_of_stock_message');
oosMessages.forEach((message)=>{
    message.textContent = 'RUPTURE'
})
    }, 100);
});

var numberOfChoices;
var num = 4;

function applyNoveauClass(){
    const names = window.noveau_tag_products ?? [];
    names.forEach((name)=>{
        document.querySelectorAll(`.bold_option_value input[value="${name}" i]`).forEach((el)=>{
            console.log('Noveau: ', el);
            el?.closest('.bold_option_value_element')?.classList.add('noveau');
        });
    });
}

function getTotalQnt() {
    let quantity = 0;
    let quantityInputs = document.querySelectorAll('.bold_option_value_quantity input');
    quantityInputs.forEach((input) => {
        quantity += parseInt(input.value);
    })
    return quantity;
}

function createSelector() {
    var nailChoice = document.querySelector('.nail-choices');
    numberOfChoices = document.querySelector('.num-of-choices');
    numberOfChoices.style.display = 'none';
    for (let i = 0; i < num; i++) {
        var choice = document.createElement('div');
        choice.classList.add('choice', 'choice' + i);
        var deleteChoice = document.createElement('div');
        deleteChoice.classList.add('choice-delete', 'choice' + i);
        deleteChoice.textContent = 'x';
        choice.appendChild(deleteChoice);
        nailChoice.appendChild(choice);
        nailChoice.addEventListener('click', toggleModal);
    }
}

function toggleModal() {
    document.querySelector('.customization-modal').classList.toggle('open-custom-modal');
    document.querySelector('.modal-body-custom').classList.toggle('modal-move');
    document.querySelector('#MainContent').classList.toggle('content-open-modal');
    document.body.classList.toggle('body-open-modal');
    document.querySelector('.bold_option_radio .bold_option_value').click();
}

function modalEvents() {
    document.querySelector('.customization-modal').addEventListener('click', function (e) {
        if (e.target.className.includes('customization-modal')) {
            toggleModal();
        } if (e.target.type === 'number') {
            if (getTotalQnt() >= num) return;
            setTimeout(() => {
                handleQuantityIncrement(e);
            }, 1)
        } if (e.target.type === 'checkbox') {
            console.log(getTotalQnt())
            if (getTotalQnt() >= num) {
                e.preventDefault();
                return
            }
            handleSwatch(e);
        } if (e.target.classList.contains('choice-delete') && e.target.parentElement.classList.contains('active_choice')) {
            handleQuantityDecrementAndSwatchDeselection(e.target);
        }
        console.log(getTotalQnt())
    })
}

function handleQuantityIncrement(e) {
    let quantityElement = e.target.closest('.bold_option_value').querySelector('.bold_option_value_quantity input');
    quantityElement.style.pointerEvents = 'none';
    if (quantityElement) {
        setTimeout(() => {
            quantityElement.setAttribute('value', parseInt(quantityElement.value) + 1)
            quantityElement.dispatchEvent(customChangeEvent);
            handleSwatch(e.target.closest('.bold_option_value').querySelector('.bold_swatch_selected input[type="checkbox"]'))
            quantityElement.style.pointerEvents = 'all';
        }, 1);
    }
}

function handleSwatch(e) {
    let swatch;
    e instanceof Event ? swatch = e.target : swatch = e
    var nailChoices = document.querySelectorAll('.modal-main-custom .nail-choices .choice:not(.active_choice)');
    nailChoices[0].style.backgroundImage = swatch.previousElementSibling.firstElementChild.style.backgroundImage;
    nailChoices[0].classList.add('active_choice');
    nailChoices[0].setAttribute('data-swatch', swatch.value);
    progressBar('increase');
    mimicSelection(nailChoices[0]);
    setTimeout(() => {
        cacheImages(swatch);
        let quantityElement = swatch.closest('.bold_option_value').querySelector('.bold_option_value_quantity input');
        quantityElement.readOnly = true;
    }, 50)
}

function mimicSelection(selected) {
    var mimic = document.querySelector('form .nail-choices' + ' .' + selected.classList[1]);
    mimic.style.backgroundImage = selected.style.backgroundImage;
    mimic.classList.add('active_choice-product');
    mimic.setAttribute('data-swatch', selected.getAttribute('data-swatch'));
    mimic.setAttribute('data-helper', selected.getAttribute('data-helper'));
    mimic.querySelector('.choice-delete').addEventListener('click', function (event) {
        handleQuantityDecrementAndSwatchDeselection(document.querySelector(`div.active_choice[data-swatch="${this.parentElement.getAttribute('data-swatch')}"]`).firstElementChild)
    })
}

function handleQuantityDecrementAndSwatchDeselection(button) {
    let parent = button.parentElement;
    let fakeParent = document.querySelector(`div.active_choice-product[data-swatch="${parent.getAttribute('data-swatch')}"]`);
    let swatch = document.querySelector(`.bold_option_value_element:has(input[value="${parent.getAttribute('data-swatch')}"]`);
    let quantityElement = swatch.closest('.bold_option_value').querySelector('.bold_option_value_quantity input');
    if (quantityElement && quantityElement.value > 1) {
        quantityElement.setAttribute('value', parseInt(quantityElement.value) - 1);
        quantityElement.dispatchEvent(customChangeEvent);
    } else {
        swatch.querySelector('input[type="checkbox"]').checked = false;
        swatch.querySelector('input[type="checkbox"]').dispatchEvent(customChangeEvent);
    }
    parent.classList.remove('active_choice');
    parent.classList.remove('active_choice-product');
    parent.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0762/5205/3840/files/Nail_choice.png?v=1718192546)';
    parent.removeAttribute('data-swatch');
    parent.removeAttribute('data-helper');
    fakeParent.classList.remove('active_choice');
    fakeParent.classList.remove('active_choice-product');
    fakeParent.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0762/5205/3840/files/Nail_choice.png?v=1718192546)';
    fakeParent.removeAttribute('data-swatch');
    fakeParent.removeAttribute('data-helper');
    progressBar('decrease');
}

function handleDelete(swatch) {
    var position = swatch.parentElement.classList[1];
    var selected = document.querySelectorAll(`.${position}:not(.choice-delete)`);
    selected.forEach((select) => {
        var name = select.getAttribute('data-swatch');
        var helper = document.querySelector(`[name="${select.getAttribute('data-helper')}"]`);
        helper.value = helper.value.replace(name + ', ', '');
        if (select.className.includes('active_choice-product')) {
            select.classList.remove('active_choice-product');
        } else {
            select.classList.remove('active_choice');
        }
        select.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0762/5205/3840/files/Nail_choice.png?v=1718192546)';
        select.removeAttribute('data-swatch');
        select.removeAttribute('data-helper');
    })
    progressBar('decrease');
}

function progressBar(action) {
    var progressBars = document.querySelectorAll('.nail-choice-progress .progress-gauge');
    var increments = parseInt(100 / num);
    progressBars.forEach((progress) => {
        if (action == 'increase') {
            progress.style.width = (parseFloat(progress.style.width) || 0) + increments + '%';
            progress.previousElementSibling.textContent = parseInt(progress.previousElementSibling.textContent.split('/')[0]) + 1 + ' sur 4';
        } else if (action == 'decrease') {
            progress.style.width = (parseFloat(progress.style.width) || 0) - increments + '%';
            progress.previousElementSibling.textContent = parseInt(progress.previousElementSibling.textContent.split('/')[0]) - 1 + ' sur 4';
        }
        setTimeout(() => {
            if (document.querySelectorAll('.active_choice').length == num) {
                progress.style.width = '100%';
                progress.style.backgroundColor = '#49c949';
                document.querySelector('.modal-header-custom span').textContent = 'choisssez vos couleurs';
                document.querySelector('.custom-drawer-title').textContent = 'Super choix ! Voici vos 4 couleurs';
                document.querySelector('.modal-header-custom').style.backgroundColor = '#cdffcd';
                document.querySelector('.bold_clone').removeAttribute('disabled');
                const price = document.querySelector(".wy-price__current").textContent;
                document.querySelector('.bold_clone > span').textContent = `Ajouter au panier - ${price}`;
                setTimeout(() => {
                    document.querySelector('.modal-header-custom').style.backgroundColor = '#fff';
                    progress.style.backgroundColor = "#47b771";
                    document.querySelector('.customization-modal').classList.remove('open-custom-modal');
                    document.querySelector('.modal-body-custom').classList.remove('modal-move');
                    document.querySelector('#MainContent').classList.remove('content-open-modal');
                    document.body.classList.remove('body-open-modal');
                }, 300);
            } else {
                progress.style.backgroundColor = "#000";
                document.querySelector('.modal-header-custom span').textContent = 'Choisissez vos couleurs';
                document.querySelector('.bold_clone').setAttribute('disabled', 'disabled');
                document.querySelector('.bold_clone > span').textContent = 'Choisissez vos couleurs';
                document.querySelector('.custom-drawer-title').textContent = 'Choisissez vos couleurs';
            }
        }, 200);
    })
}

function colorCategory() {
    var allRadios = document.querySelectorAll('.customization-modal .bold_option_radio .bold_option_value');
    allRadios.forEach((radio) => {
        radio.addEventListener('click', function () {
            document.querySelectorAll('.customization-modal .bold_option_swatch').forEach((swatch) => {
                swatch.style.display = 'none';
            })
            $(`.customization-modal .bold_option_swatch .bold_option_title:contains(${this.querySelector('.bold_option_value_title').textContent})`)[0].parentElement.style.display = 'block';
        })
    })
}

function cacheImages(option) {
    var name = option.value;
    console.log(name);
    const boldQtyHidden = document.querySelector(`[data-property-name="_boldVariantNames"][value*="${name}"]`);
    const boldQtyArr = boldQtyHidden?.value.split(',');
    var index = boldQtyArr.indexOf(name);
    var boldQtyElement = document.querySelector('[data-property-name="_boldVariantQtys"]').value.split(',');
    var qty = boldQtyElement.at(index).replace('*', ''); // pazi naziv
    var image = option.previousElementSibling.firstElementChild.style.backgroundImage.slice(5, -2);
    localStorage.setItem(name, image + '|' + qty);
}

function displayLoader() {

    const atcWrapper = document.querySelector('.pdp-action-container:has(.bold_clone)');
    const boldClone = document.querySelector('.bold_clone');
    atcWrapper.addEventListener('click', () => {
        if (!boldClone.disabled) {
            boldClone.classList.add('is-loading');
        }
    }, true)

}